import Vue from 'vue';
import Vuetify, { VSnackbar, VBtn, VIcon } from 'vuetify/lib'
import VuetifyToast from 'vuetify-toast-snackbar'

Vue.use(Vuetify, {
	components: {
		VSnackbar,
		VBtn,
		VIcon,
	},
})

const opts = {}; // your options

const vueObj = new Vuetify(opts);

export default vueObj;

Vue.use(VuetifyToast, {
	$vuetify: vueObj.framework,
	x: 'middle',
	y: 'top',
	color: 'blue', // default
	icon: 'mdi-information-outline',
	timeout: 3000, // default
	dismissable: true, // default
	autoHeight: false, // default
	multiLine: false, // default
	vertical: false, // default
	shorts: {
		success: {
			color: 'green',
			icon: 'mdi-check-circle',
		},
		error: {
			color: 'red',
			icon: 'mdi-alert-circle-outline',
		},
	},
	property: '$notify',
});
